// Pure class composition for <Card> — a neutral surface, so it carries no tone axis. Variant
// picks the surface treatment; padding is a separate scale. Split out for unit testing.
import { cn } from "./cn";

export type CardVariant = "solid" | "soft" | "outline";
export type CardPadding = "none" | "sm" | "md" | "lg";

export function cardClass(variant: CardVariant, padding: CardPadding, extra?: string): string {
  return cn("rc-card", `rc-card--${variant}`, `rc-card--pad-${padding}`, extra);
}
